import React from "react";
const ErrorMessage = (props) => {
  const { message } = props;
  return /* @__PURE__ */ React.createElement("span", { className: "form-error-message" }, message);
};
export default ErrorMessage;
